import { IGetPatientSurgeryParams, ISurgery } from '~/interfaces'
import { axios, AxiosResponse } from '~/modules'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchPatientSurgery = async (params: IGetPatientSurgeryParams): Promise<ISurgery> => {
  const { pathParams } = params

  const response = await axios.get(`${hstoryAPI}/surgeries/${pathParams.surgeryId}`)
  const { data }: AxiosResponse<ISurgery> = response
  return data
}
